import React from 'react';
import type { ImageSizes } from '../../common/lib/image-source';
import { AdImageOptionsProvider } from '../ad/AdImageOptions';

const BASE_CDN_URL = 'https://images.finncdn.no/dynamic';

const DEFAULT_RESOLUTION = 480;

const FALLBACK_IMAGE = ({ className = '' }: { className?: string }) => (
    <img
        alt=""
        className={`${className} s-bg-info-subtle`}
        src="https://static.finncdn.no/_c/mfinn/static/images/no-image.5bf83e47.svg"
    />
);

// See
// https://github.schibsted.io/finn/yams-rules/blob/master/src/main/groovy/no/finntech/image/rules/RuleBuilder.groovy
// for available sizes
const IMAGE_SIZES: ImageSizes = [
    [240, '240w'],
    [320, '320w'],
    [480, '480w'],
    [640, '640w'],
    [960, '960w'],
];

type LegendaryAdImageOptionsProps = {
    children: React.ReactNode;
};

export function LegendaryAdImageOptions(props: LegendaryAdImageOptionsProps) {
    const { children } = props;

    return (
        <AdImageOptionsProvider
            baseCdnUrl={BASE_CDN_URL}
            defaultResolution={DEFAULT_RESOLUTION}
            fallbackImage={FALLBACK_IMAGE}
            imageSizes={IMAGE_SIZES}
        >
            {children}
        </AdImageOptionsProvider>
    );
}
